import { type ChangeEventHandler, useCallback, useState } from 'react'

// useDisclosure inspired
export const useCheckboxToggle = (defaultChecked = false) => {
  const [checked, setChecked] = useState(defaultChecked)

  const toggle: ChangeEventHandler<HTMLInputElement> = useCallback((e) => {
    setChecked(e.currentTarget.checked)
  }, [])

  const unCheck = useCallback(() => {
    setChecked(false)
  }, [])

  const check = useCallback(() => {
    setChecked(true)
  }, [])

  return {
    checked,
    toggle,
    unCheck,
    check,
  }
}
